import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import { Shapes } from '../../models/entities';

class ClientForm extends PureComponent {
  constructor(props) {
    super(props);

    const { client } = props;
    if (client) {
      this.state = { ...client };
    } else {
      this.state = {
        serialId: '',
        name: '',
        usersLimit: '',
        emailDomain: '',
        enforceEmailDomain: false,
        tpsProtocol: 'REST',
        tpsInquiryUrl: '',
        tpsPaymentUrl: '',
        apiKey: '',
        validated: false,
      };
    }
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleFieldChange = (event) => {
    switch (event.target.id) {
      case 'serialId': return (this.setState({ serialId: event.target.value }));
      case 'name': return (this.setState({ name: event.target.value }));
      case 'usersLimit': return (this.setState({ usersLimit: event.target.value }));
      case 'emailDomain': return (this.setState({ emailDomain: event.target.value }));
      case 'enforceEmailDomain': return (this.setState({ enforceEmailDomain: event.target.checked }));
      case 'tpsProtocol': return (this.setState({ tpsProtocol: event.target.value }));
      case 'tpsInquiryUrl': return (this.setState({ tpsInquiryUrl: event.target.value }));
      case 'tpsPaymentUrl': return (this.setState({ tpsPaymentUrl: event.target.value }));
      case 'apiKey': return (this.setState({ apiKey: event.target.value }));
      default: return this.state;
    }
  }

  handleSubmit = (event) => {
    const { onSubmit } = this.props;

    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      const body = (({
        serialId, name, usersLimit, emailDomain, enforceEmailDomain,
        tpsProtocol, tpsInquiryUrl, tpsPaymentUrl, apiKey,
      }) => ({
        serialId,
        name,
        usersLimit,
        emailDomain,
        enforceEmailDomain,
        tpsProtocol,
        tpsInquiryUrl,
        tpsPaymentUrl,
        apiKey,
      }))(this.state);
      onSubmit(body);
    }
    this.setState({ validated: true });
  }

  render = () => {
    const {
      serialId, name, usersLimit, emailDomain, enforceEmailDomain,
      tpsInquiryUrl, tpsProtocol, tpsPaymentUrl, apiKey, validated,
    } = this.state;

    const { formId, onSubmit } = this.props;

    return (
      <Form noValidate validated={validated} onSubmit={this.handleSubmit} id={formId}>
        <Form.Row>
          <Col>
            <Form.Group controlId="serialId">
              <Form.Label>Serial ID</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={serialId}
                placeholder="Enter the company serial ID"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the company serial identifier.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={name}
                placeholder="Enter the company name"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the company name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col xs lg="3">
            <Form.Group controlId="usersLimit">
              <Form.Label>Users Limit</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                type="text"
                onChange={this.handleFieldChange}
                value={usersLimit || ''}
                placeholder="Enter the limit"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="emailDomain">
              <Form.Label>Email Domain</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                type="text"
                onChange={this.handleFieldChange}
                value={emailDomain}
                placeholder="Enter the e-mail domain"
              />
            </Form.Group>
            <Form.Group controlId="enforceEmailDomain">
              <Form.Check
                readOnly={!onSubmit}
                checked={enforceEmailDomain}
                type="checkbox"
                onChange={this.handleFieldChange}
                value={enforceEmailDomain}
                label="Enforce domain on users"
              />
            </Form.Group>
          </Col>
          <Col xs lg="3">
            <Form.Group controlId="tpsProtocol">
              <Form.Label>TPS Protocol</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                required
                as="select"
                value={tpsProtocol}
                onChange={this.handleFieldChange}
              >
                <option>REST</option>
                <option disabled>SOAP</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="tpsInquiryUrl">
              <Form.Label>TPS Inquiry URL</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={tpsInquiryUrl}
                placeholder="Enter the URL"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the TPS inquiry URL.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="tpsPaymentUrl">
              <Form.Label>TPS Payment URL</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={tpsPaymentUrl}
                placeholder="Enter the URL"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the TPS payment URL.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs lg="3">
            <Form.Group controlId="apiKey">
              <Form.Label>TPS API Key</Form.Label>
              <Form.Control
                readOnly={!onSubmit}
                type="text"
                onChange={this.handleFieldChange}
                value={apiKey}
                placeholder="Enter the API key"
              />
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

ClientForm.propTypes = {
  onSubmit: PropTypes.func,
  formId: PropTypes.string.isRequired,
  client: Shapes.CLIENT,
};

ClientForm.defaultProps = {
  client: null,
  onSubmit: undefined,
};

export default ClientForm;
